import IConditionBookPageState from "interfaces/ConditionBookPageState";
import { defaultConditionBookFiltersState } from "pages/ConditionBookPage/helper";
import {
  CLEAR_CONDITION_BOOK_FILTERS,
  IConditionBookPageAC,
  SET_CONDITION_BOOK_FILTERS,
  SET_SELECTED_FACILITY_ID,
  SET_SELECTED_RACE_ID
} from "../actions/conditionBookPage";

const initialState: IConditionBookPageState = {
  filters: defaultConditionBookFiltersState,
  selectedFacilityId: null,
  selectedRaceId: null
};

export default (
  state: IConditionBookPageState = initialState,
  action: IConditionBookPageAC
): IConditionBookPageState => {
  switch (action.type) {
    case SET_CONDITION_BOOK_FILTERS:
      return {
        ...state,
        filters: action.filters
      };
    case CLEAR_CONDITION_BOOK_FILTERS:
      return {
        ...state,
        filters: initialState.filters
      };
    case SET_SELECTED_FACILITY_ID:
      return {
        ...state,
        selectedFacilityId: action.selectedFacilityId
      };
    case SET_SELECTED_RACE_ID:
      return {
        ...state,
        selectedRaceId: action.selectedRaceId
      };
    default:
      return state;
  }
};
